import { FC } from "react";
import { Dialog } from "../../core/Dialog/Dialog";
import { useAppDispatch, useAppSelector } from "../../hooks";
import {
  selectIsSubscriptionRequiredOpen,
  setIsSubscriptionRequiredOpen,
} from "../../../store/slices/appState";
import { useTranslation } from "react-i18next";
import { useIsMainProfile } from "../../../hooks/useProfileSession";
import { isFireTv } from "../../../utils/platform";

/**
 * Shown instead of the paywall / payment pages when VITE_DISABLE_SUBSCRIPTION
 * is enabled. Mounted once at the root so any screen can trigger it.
 */
export const SubscriptionRequiredPopup: FC = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectIsSubscriptionRequiredOpen);
  const { t } = useTranslation();
  const isMainProfile = useIsMainProfile();

  const onClose = () => dispatch(setIsSubscriptionRequiredOpen(false));
  const descriptionKey = !isMainProfile
    ? "Payment_The subscription for this account isn’t active. Please ask the account owner to activate or renew it."
    : isFireTv
    ? "Payment_An active subscription is needed to play games. Once yours is active, you're ready to jump in!"
    : "Payment_An active subscription is needed to play games. For more information, visit onmoplus.com";

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      title={t("Payment_Subscription Required")}
      description={t(descriptionKey)}
      mainAction={{
        text: t("Payment_OK"),
        onClick: onClose,
        "data-gamepad": "default-selected",
      }}
    />
  );
};

export default SubscriptionRequiredPopup;
